// Inertia page resolution shared by the browser entry and the SSR entry.
const pages = import.meta.glob('../pages/**/*.vue')

export const resolvePageFrom = (pageModules, name) => {
  const page = pageModules[`../pages/${name}.vue`]

  if (!page) {
    throw new Error(`Unknown Inertia page: ${name}`)
  }

  return page().then(module => module.default)
}

export const resolvePage = name => resolvePageFrom(pages, name)

// Inertia renders the first page either as a data-page attribute on the root
// (client rendering) or, after server rendering, as a JSON script next to a
// data-server-rendered root. Support both so the fallback path keeps working.
export const initialPageFromDocument = (documentRef, id = 'app') => {
  const root = documentRef.getElementById(id)
  if (!root) return null

  if (root.dataset.page) return JSON.parse(root.dataset.page)

  const script = documentRef.querySelector(`script[data-page="${id}"][type="application/json"]`)
  return script?.textContent ? JSON.parse(script.textContent) : null
}
